// The dashboard theme renders `variant="contained"` buttons on a white surface, so a save
// button has to set its own background — white text alone leaves it invisible. Matches the
// green "Export to Excel" treatment used on the Review Queue.
export const SAVE_BUTTON_SX = {
  backgroundColor: "#2e7d32",
  color: "#fff",
  fontWeight: 600,
  whiteSpace: "nowrap",
  "&:hover": { backgroundColor: "#1b5e20" },
  "&.Mui-disabled": { backgroundColor: "#c8e6c9", color: "#33691e" },
};

// Secondary actions (Find, Add Shift) that sit next to a save button. Same reasoning as
// SAVE_BUTTON_SX: on this theme `variant="outlined"` renders a faint outline with barely
// visible label text, so these carry their own background too. Blue keeps green reserved
// for the action that commits.
export const ACTION_BUTTON_SX = {
  backgroundColor: "#1976d2",
  color: "#fff",
  fontWeight: 600,
  whiteSpace: "nowrap",
  "&:hover": { backgroundColor: "#115293" },
  "&.Mui-disabled": { backgroundColor: "#cfd8dc", color: "#546e7a" },
};
